import Vue from 'vue';
import Vuex from 'vuex';
import { SET_ACTIVE_USER_ID, TOGGLE_USER_LIMIT_FOR_DASHBOARD } from './mutation-types';
import groups from './modules/groups';
import tariff from './modules/tariff';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        groups,
        tariff
    },
    state: {
        isLimitOf10UsersReached: false,
        activeUserId: 0
    },
    getters: {
        getActiveUserId(state: any) {
            return state.activeUserId;
        }
    },
    mutations: {
        [TOGGLE_USER_LIMIT_FOR_DASHBOARD](state, isLimitOf10UsersReached: boolean) {
            state.isLimitOf10UsersReached = isLimitOf10UsersReached;
        },
        [SET_ACTIVE_USER_ID](state, userId: number) {
            state.activeUserId = userId;
        }
    }
});
